module.exports = __webpack_public_path__ + "static/media/Location.50903461.svg";